module.exports = __webpack_public_path__ + "img/index_bg_project3.79f907b9.jpg";